import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Combos/getComboNivelGeneticoActivoGranja`, method: 'POST', body: values, token: token})
}